import types from 'redux/types';

const mergeContactServlet = (data) => {
  return {
    ...data,
    type: types.REQUEST_MERGE_GROUPS,
  };
};

const splitContactServlet = (data) => {
  return {
    ...data,
    type: types.REQUEST_SPLIT_GROUPS,
  };
};

const getContactServlet = (data) => {
  return {
    type: types.REQUEST_API_CONTACT_SERVLET,
    ...data,
  };
};

const getManageContactServlet = (data) => {
  return {
    ...data,
    type: types.REQUEST_API_MANAGE_CONTACT_SERVLET,
  };
};

const getContactBelongTo = (sessionId, phone) => {
  return {
    type: types.REQUEST_API_GET_CONTACT_BELONG_TO,
    sessionId,
    phone,
  };
};

const clearContactServlet = () => {
  return {
    type: types.REQUEST_CLEAR_CONTACT_SERVLET,
  };
};

const addContact = (data) => {
  return {
    type: types.REQUEST_ADD_CONTACT,
    ...data,
  };
};

const removeContact = (data) => {
  return {
    type: types.REQUEST_REMOVE_CONTACT,
    ...data,
  };
};

const getContactEdit = (data) => {
  return {
    type: types.REQUEST_GET_EDIT_CONTACT,
    ...data,
  };
};

const clearContactEdit = (data) => {
  return {
    type: types.REQUEST_CLEAR_EDIT_CONTACT,
  };
};

const clearContactDetail = () => {
  return {
    type: types.REQUEST_CLEAR_CONTACT_DETAIL,
  };
};

const removeContactByCarrier = (data) => {
  return {
    type: types.REQUEST_DELETE_CONTACT_BY_CARRIER,
    ...data,
  };
};

const startScrub = (data) => {
  return {
    type: types.REQUEST_SCRUB_CONTACT,
    ...data,
  };
};

const getAllLandLine = (data) => {
  return {
    type: types.REQUEST_GETALL_LANDLINE_CHECK,
    ...data,
  };
};

const checkScrub = (data) => {
  return {
    type: types.REQUEST_CHECK_SCRUB,
    ...data,
  };
};

const cancelScrub = (data) => {
  return {
    type: types.REQUEST_CANCEL_LANDLINE,
    ...data,
  };
};

const clearScrub = () => {
  return {
    type: types.CLEAR_SCRUB_CONTACT,
  };
};

const getLandLineCheckStatus = (data) => {
  return {
    type: types.REQUEST_LANDLINE_CHECK,
  };
};

const removeGroup = (data) => {
  return {
    type: types.REQUEST_REMOVE_GROUP,
    ...data,
  };
};

const importFile = (data) => {
  return {
    type: types.REQUEST_IMPORT_LIST_CONTACT,
    ...data,
  };
};

const getProcessId = (data) => {
  return {
    type: types.REQUEST_GET_PROCESS_ID_IMPORT,
    ...data,
  };
};

const checkStatusImport = (data) => {
  return {
    type: types.REQUEST_CHECK_STATUS_IMPORT,
    ...data,
  };
};

const cancelImport = (data) => {
  return {
    type: types.REQUEST_CANCEL_IMPORT,
    ...data,
  };
};

const uploadListContact = (data) => {
  return {
    type: types.REQUEST_UPLOAD_LIST_CONTACT,
    ...data,
  };
};

const getPreviewLine = (data) => {
  return {
    type: types.REQUEST_GET_PREVIEW_LINE,
    ...data,
  };
};

const getHeaderField = () => {
  return {
    type: types.REQUEST_HEADER_FIELD,
  };
};

const deleteFile = (data) => {
  return {
    type: types.REQUEST_DELETE_FILE,
    ...data,
  };
};

const importFileFromStorage = (data) => {
  return {
    type: types.REQUEST_IMPORT_FROM_STORAGE,
    ...data,
  };
};

const clearImportContactDetail = () => {
  return {
    type: types.REQUEST_CLEAR_IMPORT_CONTACT,
  };
};

const searchContactServlet = (data) => {
  return {
    ...data,
    type: types.REQUEST_SEARCH_CONTACT_SERVLET,
  };
};

const changeNameContact = (data) => {
  return {
    ...data,
    type: types.REQUEST_CHANGE_NAME_CONTACT,
  };
};

const changeTypeContact = (data) => {
  return {
    ...data,
    type: types.CHANGE_TYPE_CONTACT,
  };
};

const loadMoreManageContact = (data) => {
  return {
    ...data,
    type: types.REQUEST_LOAD_MORE_CONTACT,
  };
};

const getDataConsuming = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_DATA_CONSUMING,
  };
};

const startDataConsuming = (data) => {
  return {
    ...data,
    type: types.REQUEST_START_DATA_CONSUMING,
  };
};

const getDataRefreshing = (data) => {
  return {
    ...data,
    type: types.REQUEST_GET_DATA_REFRESHING,
  };
};

const startDataRefreshing = (data) => {
  return {
    ...data,
    type: types.REQUEST_START_DATA_REFRESHING,
  };
};

const saveContactGroupLeadFilter = (data) => {
  return {
    ...data,
    type: types.REQUEST_SAVE_LEAD_FILTER,
  };
};

const setLeadCallbackLink = (data) => {
  return {
    ...data,
    type: types.REQUEST_SET_LEAD_CALLBACK_LINK,
  };
};

export default {
  setLeadCallbackLink,
  saveContactGroupLeadFilter,
  getDataConsuming,
  startDataConsuming,
  getDataRefreshing,
  startDataRefreshing,
  loadMoreManageContact,
  changeTypeContact,
  changeNameContact,
  searchContactServlet,
  splitContactServlet,
  mergeContactServlet,
  removeContactByCarrier,
  clearImportContactDetail,
  getProcessId,
  checkStatusImport,
  uploadListContact,
  getPreviewLine,
  getHeaderField,
  deleteFile,
  importFileFromStorage,
  importFile,
  cancelScrub,
  cancelImport,
  clearScrub,
  removeGroup,
  getLandLineCheckStatus,
  checkScrub,
  getAllLandLine,
  startScrub,
  getContactEdit,
  clearContactEdit,
  addContact,
  removeContact,
  getContactServlet,
  getManageContactServlet,
  clearContactServlet,
  getContactBelongTo,
  clearContactDetail,
};
